module.exports = __webpack_public_path__ + "93a09b0d5e3b535f8344a146d7e283ec.pdf";